import { useCompareUrlWithProjectId } from 'common/hooks/route';
import { PLANNING_ROUTES } from 'routes/routes.planning.const';
import { KWELLO_ICON } from '../icon/KwelloSvgIcon';
import KwelloIconButton from '../KwelloButton/KwelloIconButton';

const SHOW_NAV_BUTTON_PAGES = [PLANNING_ROUTES.profiles];

function ListsNavButton() {
  const { compareUrl } = useCompareUrlWithProjectId();

  if (!SHOW_NAV_BUTTON_PAGES.find((page) => compareUrl(page, { includes: true }))) {
    return null;
  }

  const navigateToLists = () => {
    // Navigate to lists later
  };

  return (
    <KwelloIconButton
      icon={KWELLO_ICON.LIST_ICON}
      onClick={navigateToLists}
      tooltip="Lists"
      tooltipPosition="bottom"
      disabled={true}
    />
  );
}

export default ListsNavButton;
